import { render, staticRenderFns } from "./InboundTransferTransferDetails.template.vue?vue&type=template&id=40700c02&scoped=true&"
var script = {}
import style0 from "./InboundTransferTransferDetails.template.vue?vue&type=style&index=0&id=40700c02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40700c02",
  null
  
)

export default component.exports